/** Project tab order (read-only): pinned tabs first, then the rest; the ⌘/⌥ number per project. */
import { useMemo } from 'react'
import { useProjects, useRuns } from '../../lib/queries.js'
import { isStandalone, tabShortcut } from '../../lib/shortcut.js'
import { bootstrapOrder, lastActivity, needsBootstrap, pinnedTabs } from '../../lib/tab-order.js'

export function useTabOrder(): {
  order: string[]
  label: (projectId?: string) => string | undefined
} {
  const projects = useProjects()
  const runs = useRuns()
  return useMemo(() => {
    const list = projects.data ?? []
    const fb = needsBootstrap(list)
      ? bootstrapOrder(list, lastActivity(runs.data ?? []))
      : undefined
    const pinned = pinnedTabs(list, fb)
    const order = [
      ...pinned.map((p) => p.id),
      ...list.filter((p) => !pinned.includes(p)).map((p) => p.id),
    ]
    const standalone = isStandalone()
    const pinnedIds = pinned.map((p) => p.id)
    return {
      order,
      label: (projectId) => {
        const i = projectId ? pinnedIds.indexOf(projectId) : -1
        return i >= 0 && i < 9 ? tabShortcut(i + 1, standalone) : undefined
      },
    }
  }, [projects.data, runs.data])
}
